import { ProfileCompletedChallengesSkeleton } from './profile-completed-challenges-skeleton'
import { ProfileYourAwardsCard } from './profile-your-awards-card'
import React from 'react'
import { Row } from 'react-bootstrap'
import { PageContainer } from 'src/component/page-container/page-container'
import { NoCompletedChallenges } from 'src/component/profile/no-completed-challenges'
import { Grid } from 'src/component/ui/grid/grid'
import { CompletedChallenge } from 'src/dao/core-dao'
import { useCompletedChallenges } from 'src/hook/use-challenges'

export const ProfileCompletedChallenges = (): React.ReactElement => {
  const { data: completedChallenges, isLoading, isError } = useCompletedChallenges()
  const hasCompletedChallenges = completedChallenges && completedChallenges.length > 0
  const isReady = !isLoading && !isError

  return (
    <div className="bg-ivory pb-8 md:pb-[62px]">
      <PageContainer>
        <h2 className="text-primary font-evogria text-2xl md:text-[44px] font-normal uppercase m-0 pt-8 md:pt-20 pb-5 md:pb-10">
          Your awards
        </h2>
        <>
          {isLoading || isError ? <ProfileCompletedChallengesSkeleton /> : null}
          {hasCompletedChallenges && isReady ? (
            <Grid
              columns={6}
              items={completedChallenges}
              keyExtractor={(completedChallenge) => completedChallenge.challenge.id}
              renderItem={(completedChallenge) => (
                <ProfileYourAwardsCard challenge={completedChallenge.challenge} isCompleted={true} />
              )}
            />
          ) : null}
          {isReady && !hasCompletedChallenges ? <NoCompletedChallenges /> : null}
        </>
      </PageContainer>
    </div>
  )
}
